// This file is a collection of all available actions in the application.

// module praemien
export const INIT_PRAEMIEN = "Initialize Prämien data";
